/**
 * @package FlorenceEGI — EGI — Home Supreme Islands Registry
 * @author Padmin D. Curtis (AI Partner OS3.0) for Fabio Cherici
 * @version 2.0.0
 * @date 2026-04-22
 * @purpose Dispatcher hydrate → renderer per 5 island museali.
 *          Contract: ogni renderer costruisce DOM via createElement +
 *          textContent (safe by construction). Zero HTML string raw.
 */

import { renderHeroDiptych } from "./hero-diptych";
import { renderFeaturedBento } from "./featured-bento";
import { renderCreatorsSpread } from "./creators-spread";
import { renderImpactMetric } from "./impact-metric";
import { renderCollectionsGrid } from "./collections-grid";

type HydrateFn = (
    el: HTMLElement,
    data: Record<string, unknown>,
) => Promise<void> | void;

const registry: Record<string, HydrateFn> = {
    "hero-diptych": renderHeroDiptych,
    "featured-bento": renderFeaturedBento,
    "creators-spread": renderCreatorsSpread,
    "impact-metric": renderImpactMetric,
    "collections-grid": renderCollectionsGrid,
};

export async function hydrateIsland(
    name: string,
    el: HTMLElement,
    data: Record<string, unknown>,
): Promise<void> {
    const fn = registry[name];
    if (!fn) {
        console.warn("[home-supreme] no renderer for", name);
        return;
    }
    await fn(el, data);
}
